module.exports = "/packs/images/social/home-28d53bc10895bda72f3453f5b0409fe8.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/social/home.jpg
// module id = 1808
// module chunks = 0